export default __webpack_public_path__ + "static/media/EntrySting.b068f130.mp3";